import React from 'react';
import { StyleSheet, Text, View, ScrollView, TextInput, TouchableWithoutFeedback } from 'react-native';
import MyText from './MyText';

import { connect } from 'react-redux';
import { openModal, closeModal } from './modalActions';
import stylesheet from './Style';
import { FontAwesome } from '@expo/vector-icons';
import { TouchableOpacity } from 'react-native-gesture-handler';

import * as FileSystem from 'expo-file-system';
const { StorageAccessFramework } = FileSystem;
import FileViewer from "react-native-file-viewer";
import * as Sharing from 'expo-sharing';
import * as Haptics from 'expo-haptics';
import MyDocumentModal from './MyDocumentModal';

const Documents = ({ navigation }) => {
    const css = stylesheet();

    const [documents, setDocuments] = React.useState([]);
    const [modalOpen, setModalOpen] = React.useState(false);
    const [uri, setUri] = React.useState('');
    const [name, setName] = React.useState('');

    const getFiles = async () => {
        let documents = await FileSystem.readDirectoryAsync(FileSystem.documentDirectory + 'Documents');
        let documentsMetadata = [];

        let documentsLoop = new Promise((resolve, reject) => {
            documents.forEach(async(doc, idx) => {
                documentsMetadata.push(await FileSystem.getInfoAsync(FileSystem.documentDirectory + 'Documents' + '/' + doc));
                if (idx === documents.length -1) resolve();
            })
        });
        
        documentsLoop.then(() => {
            documentsMetadata.sort((a,b) => b.modificationTime - a.modificationTime);
            setDocuments(documentsMetadata);
        });
    }
    React.useEffect(() => {
        getFiles().catch(console.error);
    },[]);

    const Clicked = (uri) => {
        FileViewer.open(uri);
    }

    const LongClicked = (uri, name) => {
        setUri(uri);
        setName(name);
        setModalOpen(true);
        Haptics.impactAsync();
    }

    const Document = ({document}) => {
        const name = document.uri.split('/').pop();
        let extension = name.split('.').pop();
        let iconName = 'file-o';
        switch(extension){
            case 'pdf':
                iconName = 'file-pdf-o';
                break;
            case 'xlsx':
                iconName = 'file-excel-o';
                break;
            case 'docx':
                iconName = 'file-word-o';
                break;
        }
        return (
            <TouchableOpacity onPress={() => Clicked(document.uri)} onLongPress={() => LongClicked(document.uri, name)} delayLongPress={300}>
                <View style={{alignItems: 'center', width: 80, flexDirection: 'column'}}>
                    <FontAwesome name={iconName} size={50} color='#461b6f' />
                    <MyText style={{marginTop: 10, flex: 1, textAlign: 'center'}}>
                        {name}
                    </MyText>
                </View>
            </TouchableOpacity>
        )
    }

  return (
    <>
        <ScrollView overScrollMode='never' vertical nestedScrollEnabled={true} keyboardShouldPersistTaps={'handled'} removeClippedSubviews={true} contentContainerStyle={{flexShrink: 0, flexGrow: 1}} scrollEnabled={true}>
        <View style={[css.background, {paddingHorizontal: 0, paddingTop: 20, marginBottom: 20}]}>
            <MyText style={[css.title, css.bold, {paddingLeft: 20}]}>
                Documents
            </MyText>
            <View style={{paddingHorizontal: 20, marginTop: 30, flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', gap: 30}}>
                {
                    documents.map((document, idx) => {
                        return <Document key={idx} document={document} />
                    })
                }
            </View>
            </View>
        </ScrollView>
        <MyDocumentModal enabled={modalOpen} uri={uri} name={name} refresh={getFiles} close={() => setModalOpen(false)} />
    </>
  );
}

const styles = StyleSheet.create({

});

const mapDispatchToProps = {
    openModal,
    closeModal,
}

export default connect(null, mapDispatchToProps)(Documents)